/**
 * Path segment for customer booking URLs (`/bookings/confirmed/:id`, `/bookings/:id/add-ons`).
 * Prefers human bookingCode (e.g. REG-5); falls back to UUID id.
 */
export function bookingRouteRef(row) {
  if (!row) return '';
  const raw = row.bookingCode ?? row.booking_code;
  const code = raw != null ? String(raw).trim().replace(/^#/, '') : '';
  if (code) return code;
  const id = row.id != null ? String(row.id).trim() : '';
  return id;
}
